import { render, staticRenderFns } from "./workspace-switch.vue?vue&type=template&id=199c292e&scoped=true"
import script from "./workspace-switch.vue?vue&type=script&lang=js"
export * from "./workspace-switch.vue?vue&type=script&lang=js"
import style0 from "./workspace-switch.vue?vue&type=style&index=0&id=199c292e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199c292e",
  null
  
)

export default component.exports